import {
  Box, Container, Flex, Heading, Icon,
} from '@chakra-ui/react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import React, { useLayoutEffect, useState, useEffect } from 'react';
import { useWindowSize } from 'react-use';
import { animated as a, useSpring } from 'react-spring';
import { GatsbyImage } from 'gatsby-plugin-image';
import { HamburgerIcon } from '@chakra-ui/icons';
import { generate } from 'shortid';
import Logo from '../../../assets/mark/mark-enhanced.svg';
import LogoIcon from '../../../assets/mark/mark-icon.svg';
import BBBSeal from '../../../assets/Ab-bbb-seal-a.svg';
import HeaderGetOffer from './header-get-offer';
import MainNav from './nav/nav';
import MenuDropDown from './nav/nav-dropdown';
import MobileNav from './nav/mobile-nav';
import { LinkPhone } from '../../_index';

const ROUTES = [
  {
    name: 'Home',
    to: '/',
    id: generate(),
  },
  {
    name: 'Reviews',
    to: '/reviews',
    id: generate(),
  },
  {
    name: 'How It Works',
    to: '/how-it-works',
    id: generate(),
  },
];

const SuperHeader = () => (
  <Flex
    backgroundColor="brand.five"
    px={2}
    width="100%"
    alignItems="center"
    justifyContent="space-between"
  >
    <Box
      className="wiggle"
      alignItems="center"
      justifyContent="space-between"
      display="flex"
      flexDir="column"
    >
      <Heading
        size="md"
        as="h6"
        mb={0}
        display={{ base: 'none', md: 'block' }}
      >
        Contact Our Team
        <LinkPhone ml={4}>510.900.8770</LinkPhone>
      </Heading>
      <Heading
        mb={0}
        size="md"
        as="h6"
        display={{ base: 'block', md: 'none' }}
      >
        Contact
        <LinkPhone ml={4}>510.900.8770</LinkPhone>
      </Heading>
    </Box>
    <Box
      width="150px"
      height="50px"
      display={{ base: 'none', md: 'block' }}
      className="hide-mobile"
      py={2}
    >
      <a href="https://bbb.org/us/ca/fremont/profile/real-estate-investing/we-buy-houses-in-bay-area-1116-918740">
        <BBBSeal
          width="150px"
          height="auto"
        />
      </a>
    </Box>
  </Flex>
);

const NavLogo = ({ showOffer, showOnLgDown, setShow }) => {
  const logoStyles = {
    display: 'flex',
    alignItem: 'center',
    justifyContent: 'center',
  };
  const hideNavEl = useSpring({
    opacity: showOffer || showOnLgDown ? 0 : 1,
    height: showOffer || showOnLgDown ? '0%' : '100%',
    width: showOffer || showOnLgDown ? '0%' : '100%',
  });
  const hideNavIcon = useSpring({
    opacity: showOffer || showOnLgDown ? 1 : 0,
    height: showOffer || showOnLgDown ? '100%' : '0%',
    width: showOffer || showOnLgDown ? '40px' : '0%',
  });
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
      onClick={() => setShow(false)}
    >
      <a.div style={{ ...hideNavIcon, logoStyles }}>
        <Link to="/">
          <LogoIcon style={{ width: '35px', height: '40px' }} />
        </Link>
      </a.div>
      <a.div style={{ ...hideNavEl, logoStyles }}>
        <Link to="/">
          <Logo style={{ width: '170px', height: '50px' }} />
        </Link>
      </a.div>
    </Box>
  );
};

const Header = ({ location }) => {
  const { width } = useWindowSize();
  const [show, setShow] = useState(false);
  const [showOffer, setShowOffer] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const [showOnLgDown, setShowOnLgDown] = useState(false);

  const styles = useSpring({
    opacity: show ? 1 : 0,
    height: show ? '100vh' : '0vh',
  });
  const hideNavEl = useSpring({
    opacity: showOffer ? 0 : 1,
    height: showOffer ? '0%' : '100%',
  });
  useEffect(() => {
    if (width < 992) {
      setShowOnLgDown((prev) => true);
    } else {
      setShowOnLgDown((prev) => false);
    }
  }, [width]);

  useLayoutEffect(() => {
    let scrollPosition = window.scrollY;
    const onScroll = () => {
      scrollPosition = window.scrollY;

      if (
        scrollPosition > 100
        && location.pathname.includes('get-offer') === false
      ) {
        setShowOffer((prev) => true);
      } else {
        setShowOffer((prev) => false);
      }
    };
    const onLoad = () => {
      scrollPosition = window.scrollY;
    };
    window.addEventListener('load', onLoad);
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [location]);

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "cropped-We_buy_houses.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200)
        }
      }
    }
  `);

  return (
    <header>
      <Flex
        position="fixed"
        top="0px"
        width="100%"
        flexDirection="column"
        zIndex="99"
      >
        <SuperHeader />
        <Box
          boxShadow="lg"
          background="white"
        >
          <Container
            maxW="container.xl"
            display={{ base: 'flex', md: 'flex' }}
            flexDir="column"
            background="white"
            zIndex="100"
            justifyContent="space-between"
            alignItems="center"
            p={4}
            py={1}
          >
            <Flex
              width="100%"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box
                flexShrink="1"
                width={{ base: '40px', md: '170px' }}
              >
                <NavLogo
                  setShow={setShow}
                  showOffer={showOffer}
                  showOnLgDown={showOnLgDown}
                />
              </Box>

              <Box
                width="100%"
                flexGrow="1"
                display={{ base: showOffer ? 'flex' : 'none' }}
              >
                <HeaderGetOffer showOffer={showOffer} />
              </Box>
              <Box display={{ base: 'none', md: 'block' }}>
                <MainNav
                  show={show}
                  isShown={isShown}
                  setShow={setShow}
                  styles={hideNavEl}
                  setIsShown={setIsShown}
                  showOffer={showOffer}
                  setShowOffer={setShowOffer}
                  ROUTES={ROUTES}
                />
              </Box>
              <Box
                onClick={() => setShow(!show)}
                display={showOnLgDown || showOffer ? 'block' : 'none'}
                overflow="hidden"
                zIndex="100"
                mr={4}
                as="button"
              >
                <Icon
                  as={HamburgerIcon}
                  w={6}
                  h={6}
                />
              </Box>
            </Flex>
          </Container>
        </Box>
        <MenuDropDown
          isShown={isShown}
          setIsShown={setIsShown}
          ROUTES={ROUTES}
        />
      </Flex>
      <MobileNav
        ROUTES={ROUTES}
        show={show}
        setShow={setShow}
        styles={styles}
      />
    </header>
  );
};

export default Header;
